
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { axiosInstance } from "@/axios.instance";
import Multiselect from "vue-multiselect";

import Axios from "axios";
import { EventDetails } from "@/store/site-monitor/types";

const SiteMonitor = namespace("siteMonitor");
const EventSearch = namespace("eventSearch");

class ReportData {
	public constructor(eventID: number, summary: string) {
		this.EventID = eventID;
		this.Summary = summary;
	}

	[key: string]: any;
	EventID: number = null;
	Summary: string = "";
}

@Component({
	components: {
		multiselect: Multiselect
	}
})
export default class IncidentReport extends Vue {
	@Prop(Number) eventid?: number;

	@SiteMonitor.Getter("getEventDetails") EventDetails: EventDetails;
	@SiteMonitor.Getter("getIncidentReportShown") incidentReportShown: any;
	@EventSearch.State IncidentReportOpen: boolean;
	@SiteMonitor.Mutation setIncidentReportShown: any;
	@EventSearch.Mutation setEventSearchIncidentReportShown: any;
	@SiteMonitor.Mutation setIncidentReportDownloaded: any;
	@EventSearch.Mutation setEventSearchIncidentReportDownloaded: any;

	private get hasLocationDetails(): boolean {
		return !(this.EventDetails == null || this.EventDetails.latLong == "");
	}

	selections: any = {
		IncludeMap: {
			title: "Map",
			selected: false
		},
		IncludeAuditTrail: {
			title: "Current Audit Trail",
			selected: false
		},
		IncludeClips: {
			title: "Event Thumbnail",
			selected: false
		},
		IncludeSnapshots: {
			title: "Video Snapshots",
			selected: false
		} 
	};

	public eventSummary: string = "";
	public generatingReport = false;
	private isReportModalShown = false;

	private async generateReport() {
		if (this.eventid == null) return;

		let reportData = new ReportData(this.eventid, this.eventSummary);

		for (let selectionKey in this.selections) {
			if (this.selections.hasOwnProperty(selectionKey)) {
				reportData[selectionKey] = this.selections[selectionKey].selected;
			}
		}

		try {
			this.generatingReport = true
			let response = await axiosInstance.post("Report/Incident", reportData);
			let incidentReportID = response.data.reportID;
			let downloadUrl = `${axiosInstance.defaults.baseURL}/Report/Incident/${incidentReportID}`;

			this.generatingReport = false;
			let link = document.createElement("a");
			link.href = downloadUrl;
			link.download = downloadUrl;

			link.click();

			this.closeModal();
			this.setIncidentReportDownloaded(true);
			this.setEventSearchIncidentReportDownloaded(true);
		} catch (e) {
			this.$notify({ type: "error", title: "Situation Report", text: "Unable to generate the report - please try again later, or contact support if the problem persists" });
		}
	}

	private created() {
		this.setIncidentReportShown(false);
		this.setEventSearchIncidentReportShown(false);
	}

	@Watch("incidentReportShown")
	onIncidentReportShownChanged(value: boolean, oldValue: boolean) {
		if (value) {
			this.setIncidentReportDownloaded(false);
			this.isReportModalShown = true;
		}
		else {
			this.isReportModalShown = false;
		}
	}

	@Watch("IncidentReportOpen")
	onEventSearchIncidentReportShownChanged(value: boolean, oldValue: boolean) {
		if (value) {
			this.setEventSearchIncidentReportDownloaded(false);
			this.isReportModalShown = true;
		}
		else {
			this.isReportModalShown = false;
		}
	}

	private closeModal() {
		this.setIncidentReportShown(false);
		this.setEventSearchIncidentReportShown(false);
	}
}
